import { useCallback, useContext } from 'react';
import { UserContext } from '../../common/auth/UserContext';
import { FETCH_POLICY_CONFIG } from '../../common/constants/constants';
import { ENTITY_CONSTANTS } from '../../common/constants/entityConstants';
import { searchClient, slimSearchQuery } from '../../common/list/slimQuery';
import {
    getSlimRepresentativeFields,
    type RepresentativeDefaults
} from '../utils/representativeDefaultsUtils';

export const useRepresentativeDefaults = () => {
    const { activeOrganizationAccount } = useContext(UserContext);

    const getRepresentativeFieldsFromSlimSearch = useCallback(
        async (personId: string): Promise<RepresentativeDefaults> => {
            if (!activeOrganizationAccount || !personId) {
                return {};
            }

            const response = await searchClient.query({
                query: slimSearchQuery(ENTITY_CONSTANTS.person, true),
                variables: {
                    entity: ENTITY_CONSTANTS.person,
                    filter: {
                        expressions: [{ field: 'identity', value: { values: [personId] } }]
                    },
                    page: { from: 0, size: 1 },
                    tokenize: false,
                    sortBy: undefined
                },
                context: {
                    headers: {
                        ownerId: activeOrganizationAccount
                    }
                },
                fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy
            });

            return getSlimRepresentativeFields(response.data?.search?.hits?.items?.[0]);
        },
        [activeOrganizationAccount]
    );

    return { getRepresentativeFieldsFromSlimSearch };
};
